import { render, staticRenderFns } from "./medicine-order-details-hipres.vue?vue&type=template&id=324dc571"
import script from "./medicine-order-details-hipres.vue?vue&type=script&lang=js"
export * from "./medicine-order-details-hipres.vue?vue&type=script&lang=js"
import style0 from "./medicine-order-details-hipres.vue?vue&type=style&index=0&id=324dc571&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports